/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_No_RatingInputs */



/**
* | output |
* | --- |
* | "No rating data available." |
*
* @param {User_Detail_No_RatingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_no_rating = /** @type {((inputs?: User_Detail_No_RatingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_No_RatingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune donnée de classement disponible.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay datos de calificación disponibles.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhum dado de rating disponível.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun dato rating disponibile.")
	return /** @type {LocalizedString} */ ("No rating data available.")
});